import {Component, OnInit} from '@angular/core';
import {IValueChange} from "../../../core/interfaces/form-value-change.interface";
import {AbstractProfileFormComponent} from "../../abstract/abstract-profile/abstract-profile-form.component";
import {BFOnValueChange} from "../../../core/interfaces/sdk-profile-hooks.interface";
import {currencyRelatedFields} from "./consts/currency-fields-mapper.const";
import {ProfileFormTemplateProviders} from "../../../core/templates/profile-form.template.providers";

@Component({
  selector: 'app-currency-preferences',
  templateUrl: '../../../core/templates/profile-form.template.html',
  styleUrls: ['../../../core/templates/profile-form.template.scss'],
  providers: ProfileFormTemplateProviders
})
export class CurrencyPreferencesComponent extends AbstractProfileFormComponent implements OnInit, BFOnValueChange {

  fgppValueChanges(change: IValueChange): void {
    if (Object.keys(currencyRelatedFields).indexOf(change.control) === -1 ) {
        return;
    }
    if(change.value && !change.value.inputValue) {
        this.emptyRelatedFields(change.control);
    } else {
      if(change.control === 'ACCOUNTS-V_SEIZE_FUNDS_SUSPENSE_ACC_NO') {
        this.handleSeizeFundsSuspense(change);
      } else {
        this.handleCurrencyFields(change.control);
      }
    }
  }

  private handleSeizeFundsSuspense(change: IValueChange) {
    const logicalFieldData = this.getDrilldownData(change.control);
    if(logicalFieldData) {
      this.form.get(currencyRelatedFields[change.control][0])
        .setValue(`${logicalFieldData['ACCOUNTS-OFFICE']}^${change.value.inputValue}^${logicalFieldData['ACCOUNTS-CURRENCY']}`);
    }
  }

  private handleCurrencyFields(control: string) {
      const relatedFields = currencyRelatedFields[control]
      const logicalFieldData = this.getDrilldownData(control);
      if(logicalFieldData) {
        for(const relatedField of relatedFields) {
          this.form.get(relatedField).setValue(logicalFieldData[relatedField]);
        }
      }
  }

  private emptyRelatedFields(control: string) {
    const relatedFields = currencyRelatedFields[control]
    for(const relatedField of relatedFields) {
      this.form.get(relatedField).reset();
    }
  }
}
